import React from 'react';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';
import { IconBadge, iconBadgeSizes } from '@components/IconBadge';
import { Checkbox } from '@components/Checkbox';

import styles from './MonitoringOptionCard.module.scss';

export const MonitoringOptionCard = ({
  id,
  icon,
  iconBg,
  title,
  description,
  checked,
  onChange,
}) => (
  <div className={styles.card}>
    <Checkbox
      id={id}
      checked={checked}
      onClick={() => onChange?.(id)}
      className={styles.checkbox}
    />
    <IconBadge size={iconBadgeSizes.md} bg={iconBg} icon={icon} />
    <Text
      variant={textVariantsEnum.Text_sm}
      fontWeight={fontWeightEnum.Semibold}
      color="gray-900"
      className={styles.title}
    >
      {title}
    </Text>
    <Text
      variant={textVariantsEnum.Text_xs}
      fontWeight={fontWeightEnum.Normal}
      color="gray-500"
    >
      {description}
    </Text>
  </div>
);

MonitoringOptionCard.displayName = 'MonitoringOptionCard';
